import { AppLogoType } from '@thoughtspot/custom-style-service';
import { useTranslation } from '@thoughtspot/i18n';
import { UserAction, userActionTypeEnum } from '@thoughtspot/metrics';
import { getOnEnter } from '@thoughtspot/radiant-react/widgets/_utils/index';
import { Icon, IconColor, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Image } from '@thoughtspot/radiant-react/widgets/image';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { RoutedLink } from '@thoughtspot/radiant-react/widgets/link';
import React, { useLayoutEffect, useRef } from 'react';
import { handleClick } from "../utils/nav-config.util";
import { useBlinkContextForGlobalNav, useValidateBlinkContextForGlobalNav, } from "../contexts/global-nav-blink-context";
import { HelpMenuContainer } from "./help-menu/help-menu.container";
import { OrgMenuContainer } from "./org-menu/org-menu.container";
import styles from './top-nav-v3.module.scss';
export var TopNavV3TestIDs;
(function (TopNavV3TestIDs) {
    TopNavV3TestIDs["HomeLink"] = "home-link";
})(TopNavV3TestIDs || (TopNavV3TestIDs = {}));
const AppLogoDefault = '/resources/img/logo/TS-logo-white-no-bg.svg';
export const TopNavV3 = ({ homeButtonConfig, searchBar, userProfile, shouldShowPendoHelp, isEmbedded = false, learningModule, isOverlayLeftPanel = false, inAppNotification, hamburgerIconHoverHandler = undefined, }) => {
    useValidateBlinkContextForGlobalNav();
    const { t } = useTranslation();
    const { sessionService, metricsService, customStylingService, navService, } = useBlinkContextForGlobalNav();
    const areProfileAndHelpHidden = sessionService.areProfileAndHelpHidden();
    const isOrgEnabled = sessionService.isOrgUiEnabled() && !sessionService.hideOrgSwitcherUi();
    const getCurrentPathByLocationHash = (includeQueryParams) => {
        return navService.getCurrentPathByLocationHash(includeQueryParams);
    };
    const logo = customStylingService
        .getConfig()
        ?.getAppLogoUrl(AppLogoType.DEFAULT, AppLogoDefault);
    const navBackground = customStylingService.getConfig()?.getAppPanelColor()
        .color;
    const navBackgroundRef = useRef(null);
    useLayoutEffect(() => {
        if (navBackgroundRef.current) {
            navBackgroundRef.current.style.setProperty('background-color', `var(--ts-var-nav-background, ${navBackground})`, 'important');
        }
    }, [navBackgroundRef.current]);
    const HomeButtonContent = React.useMemo(() => {
        const clickHandler = () => {
            handleClick(homeButtonConfig, false, getCurrentPathByLocationHash, sessionService.isReactshellEnabled());
            metricsService.collectEvent(new UserAction(userActionTypeEnum.TOP_NAV_LOGO_CLICK), {
                isDefaultLogo: true,
            });
        };
        const homeHref = `#${homeButtonConfig.target.routerURI ??
            homeButtonConfig.target.uri}` || '/';
        return (React.createElement(RoutedLink, { href: homeHref, onClick: clickHandler, noUderline: true, tabIndex: 0, onKeyDown: getOnEnter(clickHandler), "aria-label": t('Thoughtspot.home'), "data-testid": TopNavV3TestIDs.HomeLink, color: "black" },
            React.createElement(Horizontal, { className: styles.homeLink, vAlignContent: "center", basis: "224px" },
                React.createElement(Image, { className: styles.tsLogo, src: logo, fallbackSrc: AppLogoDefault }))));
    }, [homeButtonConfig]);
    const HamburgerIcon = React.useMemo(() => {
        if (isOverlayLeftPanel) {
            return (React.createElement(Vertical, { onMouseOver: hamburgerIconHoverHandler, "data-testid": "hamburger-icon" },
                React.createElement(Icon, { className: styles.hamburgerIcon, id: IconID.HAMBURGER, color: IconColor.WHITE, size: IconSize.MEDIUM })));
        }
        return React.createElement(React.Fragment, null);
    }, [isOverlayLeftPanel]);
    return (React.createElement(Horizontal, { className: styles.topNavV3 },
        HamburgerIcon,
        HomeButtonContent,
        React.createElement(Horizontal, { grow: true, hAlignContent: "right", className: styles.searchBarWrapper }, searchBar),
        !areProfileAndHelpHidden && (React.createElement(Vertical, { className: styles.helpMenuContainer },
            React.createElement(HelpMenuContainer, { isPendoHelpEnabled: shouldShowPendoHelp, learningModule: learningModule }))),
        inAppNotification,
        !isOrgEnabled ? (userProfile && !areProfileAndHelpHidden && userProfile) : (React.createElement(Horizontal, { spacing: "a", grow: 0, shrink: 0, hAlignContent: "right", className: styles.orgAndUserProfileContainer },
            React.createElement(OrgMenuContainer, { isEmbedded: isEmbedded }),
            userProfile && !areProfileAndHelpHidden && userProfile))));
};
//# sourceMappingURL=top-nav-v3.container.js.map